const CalendarIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 6.66667L2 6.66667M10.6667 1.33334V4M5.33333 1.33334V4M5.2 14.6667L10.8 14.6667C11.9201 14.6667 12.4802 14.6667 12.908 14.4487C13.2843 14.2569 13.5903 13.951 13.782 13.5747C14 13.1468 14 12.5868 14 11.4667L14 5.86667C14 4.74656 14 4.18651 13.782 3.75869C13.5903 3.38236 13.2843 3.0764 12.908 2.88466C12.4802 2.66667 11.9201 2.66667 10.8 2.66667L5.2 2.66667C4.0799 2.66667 3.51984 2.66667 3.09202 2.88466C2.71569 3.0764 2.40973 3.38236 2.21799 3.75869C2 4.18651 2 4.74656 2 5.86667L2 11.4667C2 12.5868 2 13.1468 2.21799 13.5747C2.40973 13.951 2.71569 14.2569 3.09202 14.4487C3.51984 14.6667 4.0799 14.6667 5.2 14.6667Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
